export const StepOneFields = [
  {
    name: 'name',
    label: 'Organization Name',
    rules: 'required|string',
    value: '',
  },
];
